<template>
        <TableTs ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="550">
            <div class="common-space-between" style="margin-bottom:10px;margin-top:15px">
                <div class="common-items-center">
                    <el-input v-model="param.keywords" ref="keywords" style="width:160px;margin-right: 10px;"
                    	:size="this.$store.state.btnSize" placeholder="请输入产品名称"></el-input>
                    <Month title="续费时间" ref="mouth" :width="150" @getDate="getDate"></Month>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"   @click="searchBtn">搜索</el-button>
                    <el-button class="btn-heigth" type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                </div>
                <div>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-download" :size="this.$store.state.btnSize"   @click="exportBtn">导出</el-button>
                </div>
            </div>
        </TableTs>
</template>
<script>
import { postFun,httpImg,exportFun } from '@/utils/httpFun'
import {url,api,operate} from '@/utils/config'
import { columns } from './index.js'
import Month from '@/components/component-block/block-month.vue'
import TableTs from './../../component-Table/block-table.vue'
export default {
    props:{
        belongToId:{
            type:String,
            default:()=>''
        },
        belongToType:{
            type:String,
            default: () => ''
        }
    },
    components: {
        Month:Month,
        TableTs:TableTs
    },
    data() {
        return {
            cloumn: [],
            action: operate.FUWUFEIJILI,
            param: {
                belongToId:"",
                belongToType:"",
                person:"",
				keywords:"",
                startExpirationTime:null,
                entExpirationTime:null,
                belongToId:'',
                belongToType:''
            }
        };
    },
    created() {
        this.param.belongToId = this.belongToId;
        this.param.belongToType = this.belongToType;

        console.log('=========',this.param)
    },
    mounted() {

        this.cloumn = columns(this);
    },
    methods: {

        //查询
        searchBtn(){
           this.$refs.tableData.getDatas()
        },
        //重置
        resetBtn(){
            this.param.belongToId=""
            this.param.startExpirationTime=""
            this.param.entExpirationTime=""
            this.$refs.mouth.clear()
            this.$refs.tableData.resetHttp()  
			this.$refs.keywords.clear()
        },
        
        TopUpBtn(){
            this.$refs.TopUp.openBtn({belongToId:this.$route.query.belongToId,belongToType:this.$route.query.belongToType})
        },

        //获取时间
        getDate(ev) {
            this.param.startExpirationTime = ev.startDate
            this.param.entExpirationTime = ev.endDate
        },
        //导出
        exportBtn(){
            exportFun(operate.EXPORSEVER,this.param,"服务费充值记录")
        },

        //导出
        exportBtn(){
            exportFun(api.Operate+"/financeManager/exportAccountRechargeRecord",this.param,"账户充值管理")
        }
    }
}
</script>
  
<style lang="scss" scoped>
  .title{
    color:#606266;
    margin-bottom: 15px;
  }
  .warp-block{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .block{
        margin-bottom: 10px;
        width: 33%;
        font-size: 14px;
        color:#606266;
    }
  }
</style>